import type { InvestorTitleProps } from "@/types"
import type { FC } from "react"
import { TextCols } from "../text-cols"

export const InvestorTitle: FC<InvestorTitleProps> = ({label, title}) => {

    return <section className="investorTitle">
        <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={'About Us'}
          content={{ title }}
        />
        </div>
    </section>
}